import React, { useState,useEffect } from "react";
import {
    TextField, Button, MenuItem, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Paper, FormControlLabel, Checkbox,Box
} from "@mui/material";
import { useAuth } from "../components/TokenHandler";

const DnDSelectedPatientsModal = ({ isOpen, onClose, selectedPatients, fac_id, ouid,provider_number,facility_unique_id,facility_name, onSuccess }) => {
    const { keycloak: kc, givenName,
        familyName, } = useAuth();


    const reasons = ["Discharged",
        "Insurance",
        "Not Eligible",
        "Deceased",
        "Hospice",
        "Patient Declined",
        "POA Declined",
        "Facility Declined",
        "CCM Paid to Another Provider",
        "Non-Response Opt Out",
        "N/A"]

    // State for form fields
    const [creator, setCreator] = useState("");
    const [notes, setNotes] = useState("");

    // State for CCM, RPM, RTM checkboxes and corresponding fields
    const [ccmChecked, setCcmChecked] = useState(false);
    const [ccmOptIn, setCcmOptIn] = useState(false);
    const [ccmDate, setCcmDate] = useState(null);
    const [ccmReason, setCcmReason] = useState("");

    const [rpmChecked, setRpmChecked] = useState(false);
    const [rpmOptIn, setRpmOptIn] = useState(false);
    const [rpmDate, setRpmDate] = useState(null);
    const [rpmReason, setRpmReason] = useState("");

    const [bhiChecked, setBhiChecked] = useState(false);
    const [bhiOptIn, setBhiOptIn] = useState(false);
    const [bhiDate, setBhiDate] = useState(null);
    const [bhiReason, setBhiReason] = useState("");

    const [localPatients, setLocalPatients] = useState([]);

    useEffect(() => {
        if (isOpen) {
            setLocalPatients(selectedPatients);
        }
    }, [isOpen, selectedPatients]);

    const handleRemovePatient = (patientId) => {
        setLocalPatients((prev) => prev.filter(p => p.patient_id !== patientId));
    };



    const handleSubmit = async (event) => {
        event.preventDefault();

        // Constructing the payload
        const submissionData = {
            records: localPatients.map(({ first_name, last_name, dob, patient_id, patient_uuid,mrn_id }) => ({
                patient_uuid,
                patient_id,
                first_name,
                last_name,
                dob,
                mrn_id,
                ccm: ccmChecked ? "Yes" : ccmOptIn ? "No" : "No Selection",
                ccm_date: ccmChecked || ccmOptIn ? ccmDate : null,
                ccm_reason: ccmChecked || ccmOptIn ? ccmReason : null,
                rpm: rpmChecked ? "Yes" : rpmOptIn ? "No" : "No Selection",
                rpm_date: rpmChecked || rpmOptIn ? rpmDate : null,
                rpm_reason: rpmChecked || rpmOptIn ? rpmReason : null,
                bhi: bhiChecked ? "Yes" : bhiOptIn ? "No" : "No Selection",
                bhi_date: bhiChecked || bhiOptIn ? bhiDate : null,
                bhi_reason: bhiChecked || bhiOptIn ? bhiReason : null,
                notes_free_text: notes,
                record_created_by: creator,
                facility_name,
                facility_unique_id,
                provider_number,
                facility_id:fac_id,
                ouid,
                source_system: "Tapestry Opt Out Application",
                method:"User interface selection",
            })),
        };

        console.log("Submitting:", submissionData);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/insert_optout3`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${kc.token}`,
                },
                body: JSON.stringify(submissionData),
            });

            const contentType = response.headers.get("content-type") || "";
            const body = contentType.includes("application/json")
                ? await response.json().catch(() => null)
                : await response.text().catch(() => "");

            if (response.status === 200) {
                // Success on 200 only, per your requirement
                onSuccess?.();   // Trigger fetchDndLog in the parent
                onClose?.();     // Close the modal
            } else {
                console.error("Error submitting DND data:", response.status, response.statusText, body);
            }
        } catch (error) {
            console.error("Network error submitting DND data:", error);
        }

    };

    useEffect(() => {
        if (isOpen) {
            setCreator(`${givenName} ${familyName}`);
            setNotes("");
            setCcmChecked(false);
            setCcmDate(new Date().toISOString().split("T")[0]); // Default to today
            setCcmReason("");

            setRpmChecked(false);
            setRpmDate(new Date().toISOString().split("T")[0]); // Default to today
            setRpmReason("");

            setBhiChecked(false);
            setBhiDate(new Date().toISOString().split("T")[0]); // Default to today
            setBhiReason("");
        }
    }, [isOpen, givenName, familyName]);


    useEffect(() => {
        if (!isOpen) {
            setCreator("");
            setNotes("");
            setCcmChecked(false);
            setCcmDate(new Date().toISOString().split("T")[0]); // Default to today
            setCcmReason("");

            setRpmChecked(false);
            setRpmDate(new Date().toISOString().split("T")[0]); // Default to today
            setRpmReason("");

            setBhiChecked(false);
            setBhiDate(new Date().toISOString().split("T")[0]); // Default to today
            setBhiReason("");
        }
    }, [isOpen]);

    if (!isOpen) return null;



    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <h2>Opt Out Form</h2>

                {/* Scrollable Table for Selected Patients */}
                <TableContainer component={Paper} sx={{ marginTop: "4px" }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>First Name</TableCell>
                                <TableCell>Last Name</TableCell>
                                <TableCell>Date of Birth</TableCell>
                                <TableCell>Patient ID</TableCell>
                                <TableCell>Remove patient</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {localPatients.map(({ first_name, last_name, dob, patient_id,patient_uuid }) => (
                                <TableRow key={patient_id}>
                                    <TableCell>{first_name}</TableCell>
                                    <TableCell>{last_name}</TableCell>
                                    <TableCell>{dob}</TableCell>
                                    <TableCell>{patient_id}</TableCell>
                                    <TableCell>
                                        <Button
                                            variant="text"
                                            color="error"
                                            onClick={() => handleRemovePatient(patient_id)}
                                        >
                                            X
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}

                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Form Fields */}
                <form onSubmit={handleSubmit} style={styles.form}>
                    <TextField
                        label="Creator"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={creator}
                        onChange={(e) => setCreator(e.target.value)}
                        required
                        disabled
                    />

                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell> {/* Empty cell for labels */}
                                    <TableCell align="center">Opt-Out</TableCell>
                                    <TableCell align="center">Opt-In</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Reason</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* CCM Row */}
                                <TableRow>
                                    <TableCell>CCM</TableCell>
                                    <TableCell align="center">
                                        <Checkbox
                                            checked={ccmChecked}
                                            onChange={() => {
                                                setCcmChecked(!ccmChecked);
                                                if (!ccmChecked) setCcmOptIn(false);
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        <Checkbox
                                            checked={ccmOptIn}
                                            onChange={() => {
                                                setCcmOptIn(!ccmOptIn);
                                                if (!ccmOptIn) setCcmChecked(false);
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            value={ccmDate}
                                            onChange={(e) => setCcmDate(e.target.value)}
                                            disabled={!ccmChecked && !ccmOptIn}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            select
                                            label="CCM Reason"
                                            variant="outlined"
                                            size="small"
                                            value={ccmReason}
                                            onChange={(e) => setCcmReason(e.target.value)}
                                            disabled={!ccmChecked && !ccmOptIn}
                                            sx={{ minWidth: 200 }}
                                        >
                                            <MenuItem value="" disabled>
                                                Choose a reason
                                            </MenuItem>
                                            {ccmOptIn
                                                ? <MenuItem value="Opt In">Opt In</MenuItem> // Only allow "Opt In" when opt-in is checked
                                                : reasons.map((reason, index) => (
                                                    <MenuItem key={index} value={reason}>
                                                        {reason}
                                                    </MenuItem>
                                                ))}
                                        </TextField>
                                    </TableCell>
                                </TableRow>

                                {/* RPM Row */}
                                <TableRow>
                                    <TableCell>RPMI</TableCell>
                                    <TableCell align="center">
                                        <Checkbox
                                            checked={rpmChecked}
                                            onChange={() => {
                                                setRpmChecked(!rpmChecked);
                                                if (!rpmChecked) setRpmOptIn(false);
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        <Checkbox
                                            checked={rpmOptIn}
                                            onChange={() => {
                                                setRpmOptIn(!rpmOptIn);
                                                if (!rpmOptIn) setRpmChecked(false);
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            value={rpmDate}
                                            onChange={(e) => setRpmDate(e.target.value)}
                                            disabled={!rpmChecked && !rpmOptIn}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            select
                                            label="RPMI Reason"
                                            variant="outlined"
                                            size="small"
                                            value={rpmReason}
                                            onChange={(e) => setRpmReason(e.target.value)}
                                            disabled={!rpmChecked && !rpmOptIn}
                                            sx={{ minWidth: 200 }}
                                        >
                                            <MenuItem value="" disabled>
                                                Choose a reason
                                            </MenuItem>
                                            {rpmOptIn
                                                ? <MenuItem value="Opt In">Opt In</MenuItem>
                                                : reasons.map((reason, index) => (
                                                    <MenuItem key={index} value={reason}>
                                                        {reason}
                                                    </MenuItem>
                                                ))}
                                        </TextField>

                                    </TableCell>
                                </TableRow>

                                {/* RTM Row */}
                                <TableRow>
                                    <TableCell>BHI</TableCell>
                                    <TableCell align="center">
                                        <Checkbox
                                            checked={bhiChecked}
                                            onChange={() => {
                                                setBhiChecked(!bhiChecked);
                                                if (!bhiChecked) setBhiOptIn(false);
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        <Checkbox
                                            checked={bhiOptIn}
                                            onChange={() => {
                                                setBhiOptIn(!bhiOptIn);
                                                if (!bhiOptIn) setBhiChecked(false);
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            value={bhiDate}
                                            onChange={(e) => setBhiDate(e.target.value)}
                                            disabled={!bhiChecked && !bhiOptIn}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            select
                                            label="BHI Reason"
                                            variant="outlined"
                                            size="small"
                                            value={bhiReason}
                                            onChange={(e) => setBhiReason(e.target.value)}
                                            disabled={!bhiChecked && !bhiOptIn}
                                            sx={{ minWidth: 200 }}
                                        >
                                            <MenuItem value="" disabled>
                                                Choose a reason
                                            </MenuItem>
                                            {bhiOptIn
                                                ? <MenuItem value="Opt In">Opt In</MenuItem>
                                                : reasons.map((reason, index) => (
                                                    <MenuItem key={index} value={reason}>
                                                        {reason}
                                                    </MenuItem>
                                                ))}
                                        </TextField>

                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>





                    <TextField
                        label="Notes"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        multiline
                        rows={4}
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                    />

                    {/* Buttons */}
                    <div style={styles.buttonContainer}>
                        <Button onClick={onClose} variant="outlined" color="secondary">
                            Cancel
                        </Button>
                        <Button type="submit" variant="contained" color="primary">
                            Submit
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
    },
    modal: {
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "5px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        width: "1000px",
        textAlign: "center",
        maxHeight: "85vh",
        overflowY: "auto",
    },
    tableContainer: {
        maxHeight: "200px",
        overflowY: "auto",
        marginBottom: "20px",
    },
    form: {
        display: "flex",
        flexDirection: "column",
    },
    buttonContainer: {
        marginTop: "20px",
        display: "flex",
        justifyContent: "space-between",
    },
    submitButton: {
        marginRight: "10px",
    },
    cancelButton: {
        marginLeft: "10px",
    },
};

export default DnDSelectedPatientsModal;
